import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";


const Table2 = ({ experienceScore, setExperienceScore,reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");

  const { setGreadingScore } = useContext(jobContext)

  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.experience;
    if (items) {
      const experienceData = [
        { name: "تا 2 سال تجربه مفید و مرتبط", score: 25, isSelected: items["حداقل دو سال سابقه کاری مرتبط"] || items["حداقل یک سال سابقه کاری مرتبط"] },
        { name: "تا 4 سال تجربه مفید و مرتبط", score: 50, isSelected: items["حداقل سه سال سابقه کاری مرتبط"] || items["حداقل چهار سال سابقه کاری مرتبط"] },
        { name: "تا 6 سال تجربه مفید و مرتبط", score: 75, isSelected: items["حداقل پنج سال سابقه کاری مرتبط"] || items["حداقل شش سال سابقه کاری مرتبط"] },
        { name: "تا 8 سال تجربه مفید و مرتبط", score: 100, isSelected: items["حداقل هفت سال سابقه کاری مرتبط"] || items["حداقل هشت سال سابقه کاری مرتبط"] },
        { name: "تا 10 سال تجربه مفید و مرتبط", score: 120, isSelected: items["حداقل نه سال سابقه کاری مرتبط"] || items["حداقل ذه سال سابقه کاری مرتبط"] },

      ]



      const selectedItem = experienceData.find((i) => i.isSelected)?.score
      setExperienceScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "experience": selectedItem }))
    }
  }, [reload])


  return (

    <div>
      <Row type={1}>
        <Column >تا 2 سال تجربه مفید و مرتبط</Column>
        <Column >تا 4سال تجربه مفید و مرتبط</Column>
        <Column >تا 6سال تجربه مفید و مرتبط</Column>
        <Column >تا 8سال تجربه مفید و مرتبط</Column>
        <Column >تا 10سال تجربه مفید و مرتبط</Column>
      </Row>
      <Row>
        <Column isActive={experienceScore == 25} >25</Column>
        <Column isActive={experienceScore == 50} >50</Column>
        <Column isActive={experienceScore == 75} >75</Column>
        <Column isActive={experienceScore == 100} >100</Column>
        <Column isActive={experienceScore == 120} >120</Column>
      </Row>
    </div>

  );
};

export default Table2;
